import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';

export const ShadeCircle = styled.div`
    border-radius: 50%;
    box-sizing: content-box;
    display: inline-block;
    height: 26px;
    margin: 1px ${ContentSpacing.space4};
    position: relative;
    text-align: center;
    width: 26px;
    &::after {
        border-radius: 50%;
        box-shadow: inset 0 0 0 2px transparent;
        content: '';
        display: block;
        height: 24px;
        left: 1px;
        position: relative;
        top: 1px;
        width: 24px;
    }

    &.elc-shade-circle-large {
        height: 45px;
        width: 45px;
    }
`;

export const AbsoluteShadeWrapper = styled.div`
    position: absolute;
`;
